import React from "react";
import PickupCarrierPerformanceReport from "./widgets/PickupCarrierPerformanceReport";

const Dashboard = (props) => {
  return (
    <>
      <div className="h-[290px] px-3 py-3 bg-white rounded-xl flex justify-start item-start">
        <PickupCarrierPerformanceReport />
      </div>
    </>
  );
};

export default Dashboard;
